var $ = require('jquery');
var Backbone = require('backbone');

var TemplateCache = require('TemplateCache');


var FilterInfoView = Backbone.View.extend({

	events: {
		'click .tag': 'tagClick',
	},

	initialize: function() {
		this.listenTo(this.model, "change:filterInfos", this.render);
	},

	render: function() {
		/* We need to cache that for the tagClick handler */
		this.infos = this.model.get("filterInfos");

		if ( this.infos.length > 0 ) {
			this.el.innerHTML = TemplateCache.render('filterinfo', {
				infos: this.infos,
			});
			this.$el.show();			
		} else {
			this.$el.hide().html('');
		}

	},

	tagClick: function(e) {
		var index = $(e.currentTarget).data('index');
		this.infos[index].onclick();
	},

});

module.exports = FilterInfoView;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/engine/views/FilterInfoView.js